import type { Nullable } from "../types";

/**
 * This function is used to convert minutes to hours and round them to .25 increments.
 * @param minutes
 */
export function convertMinutesToHours(minutes: Nullable<number>): number {
	if (!minutes) return 0;
	const hours = minutes / 60;
	return Math.round(hours * 4) / 4;
}
